import CryptoJS from "crypto-js";
import { getTabID } from "../Common";


const kydata = "kyt_3b_1d_1ky"
/*================ Encryption of data ======================== */

export const encryptObject = (value) => {
  const data = JSON.stringify(value);
  const encrypted = CryptoJS.AES.encrypt(data, getTabID()).toString();
  return urlSafeBase64Encode(encrypted);
};

export const decryptObject = (textToDecrypt) => {
  const decrypted = urlSafeBase64Decode(textToDecrypt);
  const bytes = CryptoJS.AES.decrypt(decrypted, getTabID());
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};


export const encryptString = (value) => {
  return CryptoJS.AES.encrypt(value.toString(), getTabID()).toString();
};

export const decryptString = (textToDecrypt) => {
  if (textToDecrypt) {
    const bytes = CryptoJS.AES.decrypt(textToDecrypt, getTabID());
    return bytes.toString(CryptoJS.enc.Utf8); // No need for JSON.parse() here for simple strings
  }
  return null;
};

export const encryptStringTID = (value) => {
  return CryptoJS.AES.encrypt(value.toString(), kydata).toString();
};

export const decryptStringTID = (textToDecrypt) => {
  if (textToDecrypt) {
    const bytes = CryptoJS.AES.decrypt(textToDecrypt, kydata);
    return bytes.toString(CryptoJS.enc.Utf8); // No need for JSON.parse() here for simple strings
  }
  return null;
};

const urlSafeBase64Encode = (value) => {
  return btoa(value).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const urlSafeBase64Decode = (value) => {
  value = value.replace(/-/g, "+").replace(/_/g, "/");
  while (value.length % 4) {
    value += "=";
  }
  return atob(value);
};
/*================ Encryption of data ======================== */
